import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/../Assets/FadyAdel.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import AOS from "aos";
import "aos/dist/aos.css";

import { supabase } from "../../utils/supabase";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);
  const [resumeUrl, setResumeUrl] = useState(pdf); // Default to local static PDF

  useEffect(() => {
    const fetchResume = async () => {
      const { data } = await supabase
        .from('about_info')
        .select('items')
        .eq('type', 'resume')
        .single();
        
      if (data?.items?.url) {
        setResumeUrl(data.items.url);
      }
    };
    fetchResume();

    AOS.init({
      duration: 2000,
      once: true,
      easing: "ease-in-out",
    });
    setWidth(window.innerWidth);
  }, []);

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={resumeUrl}
            target="_blank"
            style={{ maxWidth: "250px" }}
            data-aos="fade-up"
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>

        <Row className="resume" data-aos="fade-up" data-aos-delay="200">
          <Document file={resumeUrl} className="d-flex justify-content-center">
            <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.6} />
            </Document>
          <hr />
          <Document file={resumeUrl} className="d-flex justify-content-center">
            <Page pageNumber={2} scale={width > 786 ? 1.7 : 0.6} />
            </Document>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
